import React from "react";
import { ToastContainer } from "react-toastify";
import { useTranslation } from "react-i18next";
import { useSnapshot } from "valtio";
import { StyledBreadcrumb } from "@aureskonnect/react-ui";
import { getPathAuthorization } from "@components/VerticalLayout";
import { useLocation } from "react-router-dom";

import { setModify } from "./store";
import { store } from "@components/VerticalLayout/store";

import PageTitle from "@components/Common/PageTitle";
import MessageInfo from "@components/Common/MessageInfo";
import { MainColorTabsWrapper } from "@components/Common/MainColorTabsWrapper";
import Devises from "./Devises";
import ShopsDevise from "./ShopsDevise";
import { StyledTabs } from "./StyledTabs";

import "./index.css";
import { useSelector } from "react-redux";

export function Devise() {
    const location = useLocation();
    const authorizationList = useSelector(
        (state: any) => state.global.infoUser.profileAuthorization
    );
    const selectedAccount = useSelector(
        (state: any) => state.global.selectedAccount
    );
    setModify(
        getPathAuthorization(location.pathname, authorizationList).Modifie
    );
    const { t } = useTranslation();
    const [isDeviseArchived, setIsDeviseArchived] = React.useState<boolean>(
        false
    );
    const [limit, setLimit] = React.useState<number>(1);
    const { oneShop } = useSnapshot(store);

    const tabs1 = (
        <Devises
            isDeviseArchived={isDeviseArchived}
            setIsDeviseArchived={setIsDeviseArchived}
        />
    );

    const tabs2 = (
        <StyledTabs
            tabs={[
                {
                    content: (
                        <Devises
                            isDeviseArchived={isDeviseArchived}
                            setIsDeviseArchived={setIsDeviseArchived}
                        />
                    ),
                    disabled: false,
                    title: (
                        <div
                            className="d-flex justify-content-between text-dark cmn_btn_franchise"
                            style={{
                                gap: "10px",
                                font: "normal normal 600 16px/21px Segoe UI",
                            }}
                        >
                            {t("Currency")}
                        </div>
                    ),
                },
                {
                    content: (
                        <ShopsDevise
                            isDeviseArchived={isDeviseArchived}
                            setIsDeviseArchived={setIsDeviseArchived}
                            setLimit={setLimit}
                        />
                    ),
                    title: (
                        <div
                            className="d-flex justify-content-between text-dark border-0 cmn_btn_boutique"
                            style={{
                                gap: "10px",
                                font: "normal normal 600 16px/21px Segoe UI",
                            }}
                        >
                            {t("Currency shops")}
                        </div>
                    ),
                },
            ]}
        />
    );
    return (
        <React.Fragment>
            <ToastContainer limit={limit} />
            <PageTitle title={t("General settings")} />
            <div className="page-content__clz">
                <div className="dev_txt_currency">
                    {" "}
                    <StyledBreadcrumb
                        items={[
                            {
                                item: "Settings".toUpperCase(),
                                link: `${process.env.REACT_APP_PORTAIL_URL}`,
                            },
                            {
                                item: selectedAccount?.toUpperCase() || "",
                                link: oneShop
                                    ? "/setting/customer-account"
                                    : "/compte",
                            },
                            {
                                item: t("General settings").toUpperCase(),
                                link: "#",
                            },
                            {
                                item: !isDeviseArchived
                                    ? t("Currency").toUpperCase()
                                    : t("Archived currency").toUpperCase(),
                                link: "#",
                            },
                        ]}
                    />
                </div>

                <MessageInfo
                    message={t(
                        "The currencies used by the store are configured in this section. It is important to note that a store cannot use only one currency and that currencies are declared by country."
                    )}
                />
                <MainColorTabsWrapper>
                    {oneShop ? tabs1 : tabs2}
                </MainColorTabsWrapper>
            </div>
        </React.Fragment>
    );
}
export const Devices = React.memo(Devise);
